import React from 'react'
import AppBar from 'material-ui/AppBar'
import IconMenu from 'material-ui/IconMenu';
import Badge from 'material-ui/Badge';
import { ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import IconButton from 'material-ui/IconButton'
import { LogoutIcon, MenuIcon, BellIcon, InformationCircleIcon } from '@heroicons/react/outline'
const BASE = "https://api.notifyi.in/v1/student-activity";

const StudentAppBar = ({ title = '', router, toggleSidebar }) => {


  const sendLogoutFetch = (userId) => {
    if (!userId || typeof fetch === "undefined") return;
    try {
      const payload = JSON.stringify({ userId: Number(userId) });
      const clientId = localStorage.getItem("clientId") || (admissionApi.state && admissionApi.state.clientId) || "";
      const appId = localStorage.getItem("appId") || (admissionApi.state && admissionApi.state.appId) || "";
      fetch(`${BASE}/logout`, {
        method: "POST",
        body: payload,
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          appId,
          clientId,
        },
      }).catch(() => {});
    } catch (e) {}
  };
  const logoutUser = () => {
    // console.log("asddas")
    const userId = typeof window !== "undefined" ? window.localStorage.getItem("userId") : null;
    sendLogoutFetch(userId)
    localStorage.removeItem("isLogin");
    localStorage.removeItem("userId");

    let type = localStorage.getItem("type");
    if (type == 1) {
      let _type = 0;
      localStorage.setItem("type", _type);
      
    }
    localStorage.setItem("  ", "0");
    router.push("/");
  }

  return (
    <AppBar
      title={title}
      className="dash-app-bar"
      iconElementLeft={
        <IconButton onClick={toggleSidebar} className="menu-toggler">
          <MenuIcon className='text-lg-dark' />
        </IconButton>
      }
      iconElementRight={
        <React.Fragment>
          {/* <Badge
            badgeContent=''
            style={{ padding: 0 }}
            badgeStyle={{ width: 8, height: 8, top: 15, right: 14, backgroundColor: 'red' }}
          >
            <IconMenu
              iconButtonElement={<IconButton><BellIcon className='text-dark' /></IconButton>}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              targetOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              maxHeight={272}
              animated={false}
            >
              <ListItem
                leftAvatar={<Avatar icon={<InformationCircleIcon className='text-dark' />} />}
                primaryText="New admission alert has been posted"
                secondaryText="Jan 9, 2014"
              />
              <ListItem
                leftAvatar={<Avatar icon={<InformationCircleIcon className='text-dark' />} />}
                primaryText="New admission alert has been posted"
                secondaryText="Jan 9, 2014"
              />
              <ListItem
                leftAvatar={<Avatar icon={<InformationCircleIcon className='text-dark' />} />}
                primaryText="New admission alert has been posted"
                secondaryText="Jan 9, 2014"
              />
              <ListItem
                leftAvatar={<Avatar icon={<InformationCircleIcon className='text-dark' />} />}
                primaryText="New admission alert has been posted"
                secondaryText="Jan 9, 2014"
              />
              <ListItem
                leftAvatar={<Avatar icon={<InformationCircleIcon className='text-dark' />} />}
                primaryText="New admission alert has been posted"
                secondaryText="Jan 9, 2014"
              />
            </IconMenu>
          </Badge> */}
          <IconButton onClick={logoutUser} tooltip="Logout">
            <LogoutIcon className='text-dark logout-icon' />
          </IconButton>
        </React.Fragment>
      }
    />
  )
}

export default StudentAppBar


/** WEBPACK FOOTER **
 ** ./src/components/StudentAppBar/index.js
 **/